import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ClientAccountUpdateInput, UpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = ClientAccountUpdateInput;
type TData = UpdatePayload;

export const useClientAccountUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation clientAccountUpdate($input: ClientAccountUpdateInput!) {
      clientAccountUpdate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
